module.exports = __webpack_public_path__ + "static/media/1.44512da3.jpg";